/**
 * @type {Readonly<{
 *     MINIMUM_SEARCH_QUERY_LENGTH: number;
 *     RESULTS_PER_PAGE: number;
 *     SEARCH_WAIT_TIMEOUT: number;
 *     COLOR_WAVELENGTH_SORT_ORDER: string[];
 *     COLOR_CSS_CLASS_MAP: Object<String, String>;
 *     FACET_ICON_ID_MAP: Object<String, String>;
 * }>}
 */
export const SEARCH = Object.freeze({
    RESULTS_PER_PAGE: 25,
    MINIMUM_SEARCH_QUERY_LENGTH: 1,
    SEARCH_WAIT_TIMEOUT: 200,
});
